// extracted by mini-css-extract-plugin
module.exports = {"form":"PasswordReset_form__8puKJ"};